<script lang="ts">
  import type { Run } from '../../shared/contract'
  import Groomed from './Groomed.svelte'
  import Sign from './Sign.svelte'
  import { runLabel } from './tally'

  /** One run: its sign (hollow when closed), its name, and ≡ when groomed. No strike. */
  let { run, ghost = false }: { run: Run; ghost?: boolean } = $props()
</script>

<li class="run" class:off={!run.open} class:ghost aria-label={runLabel(run)}>
  <Sign grade={run.grade} off={!run.open} wide />
  <span class="n">{run.name}</span>
  {#if run.groomed}<Groomed />{/if}
</li>

<style>
  .run {
    display: flex;
    align-items: center;
    gap: 7px;
    min-width: 0;
    font-size: 14px;
  }
  .n {
    min-width: 0;
    line-height: 1.15;
    padding: 3px 0;
  }
  .off {
    color: var(--ink-3);
  }
  .ghost {
    opacity: 0.25;
  }
  @media (max-width: 400px) {
    .run {
      gap: 6px;
      font-size: 13px;
    }
  }
  /* The desktop board: every run on one line, in five columns. */
  :global(.board .cols) .run {
    height: 20px;
    font-size: 13px;
    break-inside: avoid;
    gap: 6px;
  }
  :global(.board .cols) .n {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 0;
  }
  :global(.board.focus .cols) .run {
    height: 26px;
    font-size: 15px;
  }
</style>
